/**
 * Mantém apenas dígitos [0-9].
 * - Aceita string/number/bigint/etc.
 * - Opcionalmente limita o tamanho.
 */
export function digits(value: unknown, opts?: { maxLength?: number }): string {
  const s = String(value ?? "");
  const only = s.replace(/\D/g, "");
  return typeof opts?.maxLength === "number" ? only.slice(0, opts.maxLength) : only;
}

/**
 * Remove diacríticos (acentos) usando NFD + faixa Unicode de combining marks.
 * Evita depender de \p{Diacritic} pra máxima compatibilidade.
 */
export function stripDiacritics(s: string): string {
  // NFD separa caracteres em base + acento(s). A regex remove os acentos.
  return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

/**
 * Normaliza texto para comparação/pesquisa:
 * - trim (padrão: true)
 * - lower/upper (padrão: lower)
 * - remove diacríticos (padrão: true)
 * - collapse de espaços múltiplos em 1 (padrão: false)
 */
export function norm(
  value: unknown,
  opts?: {
    case?: "lower" | "upper" | "none";
    trim?: boolean;
    removeDiacritics?: boolean;
    collapseWhitespace?: boolean;
  }
): string {
  const {
    case: casing = "lower",
    trim = true,
    removeDiacritics = true,
    collapseWhitespace = false,
  } = opts ?? {};

  let s = String(value ?? "");

  if (trim) s = s.trim();
  if (removeDiacritics) s = stripDiacritics(s);
  if (collapseWhitespace) s = s.replace(/\s+/g, " ");
  if (casing === "lower") s = s.toLowerCase();
  else if (casing === "upper") s = s.toUpperCase();

  return s;
}
